import script from "./BackToTopButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackToTopButton.vue?vue&type=script&setup=true&lang=ts"

import "./BackToTopButton.vue?vue&type=style&index=0&id=1c0a1d84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c0a1d84"]])

export default __exports__